<template>
  <FormulateInput
    type="triotecaDatepicker"
    name="birthDate"
    :label="showLabel ? 'Fecha de nacimiento' : ''"
    :help="help"
    :helpPosition="helpPosition"
    :validation="validationRules"
    :validation-messages="validationMessages"
    :open-date="averageAge"
    initial-view="year"
    :disabledDates="disabledDates"
  >
  </FormulateInput>
</template>
<script>
import moment from 'moment';
import { MINAGE, MAXAGE, AVERAGE_AGE } from '@/constants/age';

export default {
  props: {
    validation: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    help: {
      type: String,
      default: '',
    },
    helpPosition: {
      type: String,
      default: '',
    },
    signatureDate: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
    };
  },
  computed: {
    averageAge() {
      return moment()
        .subtract(AVERAGE_AGE, 'years')
        .calendar();
    },
    disabledDates() {
      return {
        to: this.oldest,
        from: this.youngest,
      };
    },
    youngest() {
      var youngest = new Date();

      if (this.signatureDate) {
        youngest = new Date(this.signatureDate);
      }

      youngest.setFullYear(youngest.getFullYear() - MINAGE);
      return youngest;
    },
    oldest() {
      const oldest = new Date();
      oldest.setFullYear(oldest.getFullYear() - MAXAGE);
      oldest.setDate(oldest.getDate() - 1);
      return oldest;
    },
    validationMessages() {
      return {
        required: 'La fecha de nacimiento es obligatoria.',
        after: 'La mayoría de los bancos establecen los 80 años de edad máximo para finalizar el pago de hipoteca.',
        before: this.$page.props.isImproveMortgage
          ? 'Deberías tener al menos 18 años en la fecha de firma.'
          : 'Debes tener al menos 18 años para poder solicitar una hipoteca.',
      };
    },
    validationRuleAfterDate() {
      return moment()
        .subtract(MAXAGE, 'years')
        .subtract(1, 'days')
        .format('MM/DD/YYYY');
    },
    validationRuleBeforeDate() {
      return moment(this.youngest)
        .add(1, 'days')
        .format('MM/DD/YYYY');
    },
    validationRules() {
      return !!this.validation ? this.validation : `required|after:${this.validationRuleAfterDate}|before:${this.validationRuleBeforeDate}`;
    },
  },
};
</script>
